(function () {
    'use strict';

    angular
        .module('app.ReturnOnInvestmentSetting',[])
        .factory('ReturnOnInvestmentSettingService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope){
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    }

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes) || result);
                        }
                    })
                        .error(function (result) {
                            deferred.reject(result);
                        });

                    return deferred.promise;
                }

                function getCPM(params, loader)
                {
                    var url_getCPM = $rootScope.apiUrl + 'measure/getCPM?' + $.param(params);
                    return handleRequest(url_getCPM, 'GET', params, loader);
                }

                function setCPM(params, loader)
                {
                    var url_setCPM = $rootScope.apiUrl + 'measure/setCPM?' + $.param(params);
                    return handleRequest(url_setCPM, 'GET', params, loader);
                }

                service.getCPM = getCPM;
                service.setCPM = setCPM;
                return service;
            }
        ])
})();
